import React from 'react';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { connect } from 'react-redux';
import PeoplePicker  from '../../formFields/PeoplePicker';
import { ADD_SPONSOR } from '../../../actions/types';
import { isSponsorValid } from './Validator';
import InfoTooltip from '../../formFields/InfoTooltip';
import {Icon} from '@fluentui/react';

const warningIcon = <div className='warning-inline warning-nolabel'><Icon  iconName="Warning"/></div>

class Sponsor extends React.Component {

    _onSelectedUser = (items) => {
        this.props.addSponsor(items);
    }

    render() {
        const warning = this.props.possibleWarning && !isSponsorValid()
                        ? warningIcon : null;
        const error = warning && 'Sponsor cannot be empty';

        return (
            <div className='wizard-inside-third'>
                <div className="item-Owner">
                    Sponsor
                    <InfoTooltip content='The sponsor will be team administrator and will have access to the “General” and the "Governance" team channels. This configuration can be later changed by any other team administrator, if needed.' />
                </div>
                <PeoplePicker
                    defaultUsers={this.props.sponsor}
                    onSelectedUsers={this._onSelectedUser} 
                    itemLimit={this.props.isIAPCP ? undefined : 1}
                    errorMessage={error}
                />
            </div>
        );
    }
}

// Approver.propTypes = {
//     addApprover: PropTypes.func.isRequired,
//     approver: PropTypes.object,
//     currentUser: PropTypes.object,
//     manager: PropTypes.object,
//     owner: PropTypes.object,
// }


const mapActionToProp = (dispatch) => ({
    addSponsor: (element) => { dispatch(addElement(ADD_SPONSOR, element)) }
})

const mapStateToProps  = state => ({
    currentUser: state.user.currentUser,
    sponsor: state.newSite.Sponsor,
    possibleWarning : state.wizard.nextStepRequested,
    isIAPCP :  state.newSite.isIAPCP
})

export default connect(mapStateToProps, mapActionToProp)(Sponsor);







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step5/Sponsor.js